import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContentfulService } from '../../core/_services/contentful.service';
import { Entry } from 'contentful';
import { DOCUMENT } from '@angular/common';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { SEOService } from '../../core/_services/seo.service';
import { NgIf, NgFor } from '@angular/common';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor]
})
export class ContactComponent implements OnInit {

  contactPageContents: Entry<any>[] = [];
  contactPageContent: Entry<any>;
  show = false;

  returnHtmlFromRichText(richText: any) {
    if (
      richText === undefined ||
      richText === null ||
      richText.nodeType !== 'document'
    ) {
      return '<p>Error</p>';
    }
    let options = {
      renderNode: {
        'embedded-asset-block': (node) =>
          `<img class="image" src="${node.data.target.fields.file.url}" />`
      }
    };
    return documentToHtmlString(richText, options);
  }

  constructor(@Inject(DOCUMENT) private document: Document,
    private SEOService: SEOService,
    private route: ActivatedRoute,
    private cs: ContentfulService) { }

  ngOnInit(): void {
    setTimeout(() => {
      gsap.set('.section', { y: 30, scale: 0.9 });
      this.animate();
    }, 900);
    const { meta } = this.route.snapshot.data;
    this.SEOService.updateTitle(meta.title);
    this.SEOService.updateOgTitle(meta.title);
    this.SEOService.updateTwitterTitle(meta.title);
    this.SEOService.updateDescription(meta.description);
    this.SEOService.createCanonicalLink(meta.url);
    this.SEOService.updateOgUrl(meta.url);
    this.SEOService.updateTwitterUrl(meta.url);
    this.cs.getContactPageContent()
      .then(content => {
        this.contactPageContent = content;
        this.show = true;
      });
  }

  animate(): void {
    let project_item = this.document.querySelectorAll('.section');
    gsap.set(project_item, { y: 100 });

    ScrollTrigger.batch(project_item, {
      onEnter: batch => gsap.to(batch, { opacity: 1, y: 0, scale: 1, stagger: { each: 0.05, grid: [1, 2] }, overwrite: true })
    });
  }

}
